import { render, staticRenderFns } from "./TableLiveTournaments.vue?vue&type=template&id=1bae7f51&scoped=true"
import script from "./TableLiveTournaments.js?vue&type=script&lang=js&external"
export * from "./TableLiveTournaments.js?vue&type=script&lang=js&external"
import style0 from "./TableLiveTournaments.vue?vue&type=style&index=0&id=1bae7f51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bae7f51",
  null
  
)

export default component.exports